import Immutable from 'immutable';

const UPDATE_VIDEO_COUNT = 'video/UPDATE_VIDEO_COUNT';
const UPDATE_VIDEO_COUNT_SUCCESS = 'video/UPDATE_VIDEO_COUNT_SUCCESS';
const UPDATE_VIDEO_COUNT_FAIL = 'video/UPDATE_VIDEO_COUNT_FAIL';

const initialState = Immutable.fromJS({
  errorMessage: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case UPDATE_VIDEO_COUNT:
      return state
            .set('errorMessage', null);

    case UPDATE_VIDEO_COUNT_FAIL:
      return state
        .set('errorMessage', action.errorMessage);

    case UPDATE_VIDEO_COUNT_SUCCESS:
      return state
        .set('errorMessage', null);
    default:
      return state;
  }
}

export const updateVideoViewCount = (id) => async (dispatch, getState, api) => {
  dispatch({ type: UPDATE_VIDEO_COUNT });
  try {
    let data = {
      id: id
    };
    const res = await api.put('/videos/view/count' , {data});
    if (res.message) {
      dispatch({ type: UPDATE_VIDEO_COUNT_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: UPDATE_VIDEO_COUNT_SUCCESS });
  } catch (error) {
    dispatch({ type: UPDATE_VIDEO_COUNT_FAIL, errorMessage: error });
  }
};


// WEBPACK FOOTER //
// ./src/redux/modules/video.js